import { render, staticRenderFns } from "./reset_password2.vue?vue&type=template&id=f9aa5d32&scoped=true&"
import script from "./reset_password2.vue?vue&type=script&lang=ts&"
export * from "./reset_password2.vue?vue&type=script&lang=ts&"
import style0 from "./reset_password2.vue?vue&type=style&index=0&id=f9aa5d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9aa5d32",
  null
  
)

export default component.exports